import gql from 'graphql-tag'

export const CRUISE_DESTINATION_DETAIL = gql`
query CruiseDestinationDetail(
    $departureType: String!,
    $departureId: ID!,  
    $cruiseId: String!,
    $citizenshipIds: [ID]!,
    $restrictionType: String!,
    $cruiseDateStart: Date!,

    $transitTypes: [String],
    $transitIds: [ID],
  ) {
  cruiseDestinationDetail(
      departureType: $departureType,
      departureId: $departureId,
      cruiseId: $cruiseId,
      citizenshipIds: $citizenshipIds,
      restrictionType: $restrictionType,
      cruiseDateStart: $cruiseDateStart,
      transitTypes: $transitTypes,
      transitIds: $transitIds,      
  ){
    departureType
    departureId
    destinationsTypes
    destinationIds
    destinationsIso2
    citizenshipsCountry
    citizenshipCountryIds
    transitTypes
    transitIds
    transitNames
    destinationsNames
    departureName
    dateStart
    dateEnd
    restrictionType
    cruiseId
    url
  }
}
`

export const ROUTE_DETAIL = gql`
query RouteDetail(
    $shippingLine: ID,
    $ship: ID,  
    $route: ID
  ) {
  routes(
    shippingLine: $shippingLine,
    ship: $ship,
    route: $route,
  ){
    results {
      name
      ship {
        name
        shippingLine {
          name
        }
      }
      stops {
        latitude
        longitude
        name
      }
    }
  }
}
`